import { useEffect } from 'react'

const DURATION_MS = 1000

export default function WandAnim({ onDone, startPos }) {
  useEffect(() => {
    const t = setTimeout(() => onDone?.(), DURATION_MS)
    return () => clearTimeout(t)
  }, [onDone])

  // ~half of 1.8rem emoji (16px base = 28.8px → 14px half)
  const half = 14
  const sl = startPos ? `${Math.round(startPos.x - half)}px` : '16px'
  const sb = startPos ? `${Math.round(window.innerHeight - startPos.y - half)}px` : '72px'

  // Desktop (startPos fourni) : centrer dans le volet droit (aside w-96 = 24rem)
  // Mobile : centre de l'écran
  let endLeft
  if (startPos) {
    const remPx = parseFloat(getComputedStyle(document.documentElement).fontSize)
    const asideWidth = 24 * remPx
    const emojiHalfPx = 2.5 * remPx // 5rem / 2
    endLeft = `${Math.round(window.innerWidth - asideWidth / 2 - emojiHalfPx)}px`
  } else {
    endLeft = 'calc(50vw - 1.5rem)'
  }

  const style = `
@keyframes wandFly {
  0%   { bottom: ${sb}; left: ${sl}; font-size: 1.8rem; opacity: 1; }
  65%  { bottom: 45vh; left: ${endLeft}; font-size: 5rem; opacity: 1; }
  100% { bottom: 45vh; left: ${endLeft}; font-size: 5rem; opacity: 0; }
}
.wand-fly {
  position: fixed;
  z-index: 9999;
  pointer-events: none;
  animation: wandFly ${DURATION_MS}ms ease-in-out forwards;
  line-height: 1;
}
`

  return (
    <>
      <style>{style}</style>
      <span className="wand-fly" aria-hidden="true">🪄</span>
    </>
  )
}
